import { NavLink } from 'react-router';

import { UikitMenuSidebar } from '../../components/UikitMenuSidebar';
import { UikitMenu } from '../../components/UikitMenu';
import { routes } from '../../routes';
import { guidelineNavigationGroups } from './GuidelineNavigation';

const base = `/${routes.START}`;
const title = 'Getting started';

const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

export const getStartMenuItems = () => {
    const menu = [
        {
            group: 'Welcome',
            navItems: [
                {
                    key: 'Intro',
                    meta: 'intro',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/intro`}>
                            Intro
                        </NavLink>
                    ),
                },

                {
                    key: 'Changelog',
                    meta: 'changelog',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/changelog`}>
                            Changelog
                        </NavLink>
                    ),
                },
            ],
        },
        {
            group: 'Setup',
            navItems: [
                {
                    key: 'How to',
                    meta: 'howto installation',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/howto`}>
                            Installation
                        </NavLink>
                    ),
                },
                {
                    key: 'Migration Guides',
                    meta: 'migration guide upgrade native table table component',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/migrationGuides`}>
                            Migration Guides
                        </NavLink>
                    ),
                },
                {
                    key: 'Supported Browsers',
                    meta: 'supported-browsers',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/supported-browsers`}>
                            Supported Browsers
                        </NavLink>
                    ),
                },
                {
                    key: 'Static files',
                    meta: 'static files assets cdn fonts icons illustrations logos favicon browser check',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/static-files`}>
                            Static files
                        </NavLink>
                    ),
                },
            ],
        },
        ...guidelineNavigationGroups.map(group => ({
            group: group.group,
            navItems: group.items.map(({ key, label, meta, path }) => ({
                key,
                meta,
                item: (
                    <NavLink className={navLinkClass} to={path}>
                        {label}
                    </NavLink>
                ),
            })),
        })),
        {
            group: 'Demo service',
            navItems: [
                {
                    key: 'Table',
                    meta: 'table',
                    item: (
                        <NavLink className={navLinkClass} to='/demoService/table'>
                            Table
                        </NavLink>
                    ),
                },
                {
                    key: 'Website',
                    meta: 'website landing page truckstream',
                    item: (
                        <NavLink className={navLinkClass} to='/demoWebsite'>
                            Website
                        </NavLink>
                    ),
                },
            ],
        },
    ];

    return menu.map(item => ({ ...item, badge: title }));
};

export const StartMenu = () => (
    <UikitMenuSidebar title={title}>
        <UikitMenu />
    </UikitMenuSidebar>
);
